import { Component, OnDestroy, OnInit } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { Router, ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { ITableColumnHeader } from "src/app/models/table-column-header";
import { ApiService } from "src/app/providers/api.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { NavigationService } from "src/app/providers/navigation.service";
import { CustomConfirmDialogComponent } from "src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
import { InventoryItemsForMiscComponent } from "src/app/shared/components/inventory-items-for-misc/inventory-items-for-misc.component";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { YoutubeEmbedVideoComponent } from "../new-v2-pages/new-v2-component/youtube-embed-video/youtube-embed-video.component";
import { AuthService } from "src/app/providers/auth.service";
import { DialogService } from "src/app/providers/dialog.service";

@Component({
  selector: "sm-inventory-items",
  templateUrl: "./inventory-items.component.html",
  styleUrls: ["./inventory-items.component.scss"],
})
export class InventoryItemsComponent implements OnInit, OnDestroy {
  inventoryItemsData: any[] = [];
  tableDisplayColumn: ITableColumnHeader[] = [
    {
      columnName: this.translateService.instant(
        "inventory_items.column_headers.name"
      ),
      columnProperty: "item_name",
    },
    {
      columnName: this.translateService.instant(
        "inventory_items.column_headers.desc"
      ),
      columnProperty: "item_desc",
    },
    {
      columnName: this.translateService.instant(
        "inventory_items.column_headers.qty"
      ),
      columnProperty: "quantity_info",
    },
    {
      columnName: this.translateService.instant(
        "inventory_items.column_headers.unit"
      ),
      columnProperty: "purchase_unit",
    },
    {
      columnName: this.translateService.instant(
        "inventory_items.column_headers.current_stock"
      ),
      columnProperty: "current_stock",
    },
    {
      columnName: this.translateService.instant(
        "inventory_items.column_headers.minimum_stock"
      ),
      columnProperty: "min_stock",
    },
  ];
  entityHashId: string = "";
  entityHashIdForSearch: string = "";
  datalength!: number;
  public page: number = 1;
  public loader: boolean = false;
  _apiSubscription: Subscription;
  searchString: UntypedFormControl = new UntypedFormControl("");

  constructor(
    private translateService: TranslateService,
    private _navService: NavigationService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private _apiService: ApiService,
    private loaderservice: LoaderServiceService,
    private route: ActivatedRoute,
    private authService:AuthService,
    private _modelRef: MatDialog,
    private dialogService:DialogService
  ) {
    this._navService.hideSidebarAndNav = false;

    this._apiSubscription = this._apiService.apiResult.subscribe((resData) => {
      if (resData) {
        if (
          resData.responseType === SM_CONSTANTS.RESULT_API_GET_INVENTORY_ITEMS
        ) {
          this.inventoryItemsData = [];
          if (resData.result && resData.result != "null") {
            this.inventoryItemsData = resData.result;
            this.datalength = resData.result ? resData.result[0].totalCount : 0;
              this.inventoryItemsData = resData.result.map((item:any) => {
                const newItem = { ...item };

                newItem.c_stock = item.for_sale == 1 ? `${item.current_purchase_stock} ${item.purchase_unit} (${item.current_selling_stock} ${item.selling_unit})` : `${item.current_purchase_stock} ${item.purchase_unit}` ;
                newItem.m_stock = `${item.min_stock} ${item.purchase_unit}`;
                newItem.s_unit = item.for_sale == 1 ? item.selling_unit : '---';

                return newItem;
            });
          }

          this.loader = false;
          this.loaderservice.showLoader = false;
        } else if (
          resData.responseType ===
          SM_CONSTANTS.RESULT_API_ADD_EDIT_INVENTORY_ITEM
        ) {
          if(this.isfromhere){
            this.isfromhere = false
            if (resData.result && resData.result != null) {
              if(resData.result.errorcode == 0){
                // this.page = 1;
                this._apiService.getInventoryItems(
                  this.entityHashId,
                  this.page.toString(),
                  this.searchString.value ?? ""
                );
  
              }
              else{
                this.loaderservice.showLoader = false
                  const dialogRef = this._modelRef.open(CustomConfirmDialogComponent,{
                    width:'450px',
                    data : {
                      title : 'Alert!',
                      message : 'The item is linked with a selling product. Edit or delete not possible. Either you need to delete the product first from Product section or create a new item instead.',
                      okbtn : 'Ok',
                      cancelbtn : 'Cancel',
                      type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
                    },
                    disableClose : true
                  });
              }
            }

          }
        }
      }
    });
  }
  private updateColumnHeaders() {
    this.tableDisplayColumn.forEach((column, index) => {
      let data = [
        "name",
        "desc",
        "qty",
        "unit",
        "current_stock",
        "minimum_stock",
      ];
      // Update each column header with the translated value
      column.columnName = this.translateService.instant(
        `expenses.column_headers.${data[index]}`
      );
    });
  }
  isOwner: boolean = false;
  ngOnInit(): void {
    this.isOwner = this.authService.isOwner();
    this.loader = true;
    this.loaderservice.showLoader = true;
    this.route.queryParams.subscribe((data) => {
      console.log(data.entityHash);
      this.entityHashId = data.entityHash;
      // this.entityHashIdForSearch = data.entityHash
    });

    this._apiService.getInventoryItems(
      this.entityHashId,
      this.page.toString(),
      this.searchString.value ?? ""
    );
  }
  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe;
  }

  onCreateNewService() {
    let data =  {
      title: "Add inventory item",
      operation_type: 3, //new operation directly jump to create inventory modal
      ref: this._modelRef,
      toShowTemplate: false,
    }
    let dialogref = this.dialogService.openFullScreenDialog(InventoryItemsForMiscComponent,data);
    dialogref.afterClosed().subscribe(data => {
      if(data){
        
        this._apiService.getInventoryItems(
          this.entityHashId,
          this.page.toString(),
          this.searchString.value ?? ""
        );
      }
    })
  }
  onCreateNewServiceFromTemplate() {
    let data = {
      title: "Add inventory item",
      operation_type: 4, //open inventory template
      ref: this._modelRef,
      toShowTemplate: true,
    }
    let dialogref = this.dialogService.openFullScreenDialog(InventoryItemsForMiscComponent,data);
    dialogref.afterClosed().subscribe(data => {
      if(data){
        
        this._apiService.getInventoryItems(
          this.entityHashId,
          this.page.toString(),
          this.searchString.value ?? ""
        );
      }
    })
  }

  onPageChange(ev: any) {
    console.log(ev?.pageIndex + 1);
    this.page = ev?.pageIndex + 1;

    this._apiService.getInventoryItems(
      this.entityHashId,
      this.page.toString(),
      this.searchString.value ?? ""
    );
  }
  reset() {
    this.searchString.reset();
    this.page = 1;
    this._apiService.getInventoryItems(
      this.entityHashId,
      this.page,
      this.searchString.value ?? ""
    );
  }
  firstTimeBelow3: boolean = false;

  searchServiceData() {
    if (this.searchString.value.length >= 3) {
      this.firstTimeBelow3 = true;
      this.page = 1;
      this._apiService.getInventoryItems(
        this.entityHashId,
        this.page,
        this.searchString.value ?? ""
      );
    } else {
      if (this.firstTimeBelow3) {
        this.firstTimeBelow3 = false;
        this.page = 1;
        this._apiService.getInventoryItems(this.entityHashId, this.page, "");
      }
    }
  }

  editInventoryItem(rowvalue: any) {
    let data = {
      title: "Add inventory item",
      operation_type: 3, //new operation directly jump to create inventory modal
      ref: this._modelRef,
      toShowTemplate: false,
      inventoryData: rowvalue,
    }
    let dialogref = this.dialogService.openFullScreenDialog(InventoryItemsForMiscComponent,data);
    dialogref.afterClosed().subscribe(data => {
      if(data){
        
        this._apiService.getInventoryItems(
          this.entityHashId,
          this.page.toString(),
          this.searchString.value ?? ""
        );
      }
    })
  }
  isfromhere: boolean = false
  deleteInventoryItem(rowvalue: any) {
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      width: "400px",
      data: {
        title: "Alert",
        message: "Are you sure you want to remove this item from inventory?",
        okbtn: "Yes",
        cancelbtn: "No",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      console.log(result);
      if (result) {
        this.isfromhere = true
        let bodyData = {
          hash_id: rowvalue.hash_id,
          entity_hash_id: this.entityHashId,
          accountHashId: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
          status: 0,
        };

        this.loaderservice.showLoader = true;
        this._apiService.addEditInventoryItem(bodyData);
      }
    });
  }

  openvideo() {
    this._modelRef.open(YoutubeEmbedVideoComponent, {
      width: "1000px",
      disableClose: true,
      data: {
        link: "",
        title: "Business profile",
      },
    });
  }

  opencontact() {
    this.router.navigate(["/contact-us"]);
  }
  openLink(url: string): void {
    window.open(url, "_blank");
  }
}
